<template>
  <div>
    <popup-add-task ref="popupAddTask" />
    <vs-list>
      <tippy v-for="task in tasksToday" :key="task.venueTaskId">
        <template v-slot:trigger>
          <vs-list-item
            :title="task.title"
            :subtitle="taskSubtitle(task)"
            @click.native="$refs.popupAddTask.showWith(task)"
          >
            <div class="flex flex-wrap" style="max-width: 36px">
              <feather-icon
                v-if="task.flagged"
                icon="FlagIcon"
                svgClasses="w-4 h-4 text-warning"
                style="flex: 50%"
              />
              <feather-icon
                v-if="task.hasLocation"
                icon="NavigationIcon"
                svgClasses="w-4 h-4 text-warning"
                style="flex: 50%"
              />
              <feather-icon
                v-if="task.hasResponsible"
                icon="UserIcon"
                svgClasses="w-4 h-4 text-warning"
                style="flex: 50%"
              />
              <feather-icon
                v-if="task.hasImage"
                icon="ImageIcon"
                svgClasses="w-4 h-4 text-warning"
                style="flex: 50%"
              />
            </div>
            <template slot="avatar">
              <vs-checkbox
                v-model="task.completed"
                @click.native.stop="changeCompleted(task, !task.completed)"
              ></vs-checkbox>
            </template>
          </vs-list-item>
        </template>

        <!-- The information in the tooltip -->
        <div class="popup-container text-left" style="min-width: 240px">
          <vs-row>
            <h4 class="task-title">{{ task.title }}</h4>
          </vs-row>
          <vs-row>
            <feather-icon
              v-if="task.flagged"
              class="mr-2"
              icon="FlagIcon"
              svgClasses="w-4 h-4 text-warning"
            />
            <span class="mr-2">{{ moment(task.startDate).format("HH:mm") }}</span>
            <span>{{ task.roleTitle }}</span>
          </vs-row>
          <vs-row v-if="task.hasResponsible" class="my-2">
            <span>Assigned to {{ task.responsibleName }} </span>
          </vs-row>
          <vs-row class="my-2">
            <span>{{ task.note }} </span>
          </vs-row>
          <vs-row>
            <img v-if="task.hasImage" class="task-image" :src="task.imageUrls[0]" />
          </vs-row>
        </div>
      </tippy>
    </vs-list>
  </div>
</template>

<style scoped></style>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import PopupAddTask from "./PopupAddTask.vue";
import "tippy.js/dist/tippy.css";

export default {
  props: ["tasks", "date", "showCompleted"],
  data() {
    return {
      drag: false,
      roleMap: {
        hq: "Marketing",
        vm: "Venue Manager",
        sm: "Shift Manager",
      },
      moment,
    };
  },
  components: {
    PopupAddTask,
    draggable,
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    tasksToday() {
      var unsorted = this.tasks
        .filter(e => moment(e.instanceDate).isSame(this.date, "day"))
        .map(e => {
          return {
            ...e,
            hasLocation: e.address,
            hasResponsible: e.responsibleUserId != null && e.responsibleUserId != "",
            hasImage: e.imageUrls.length > 0,
            roleTitle: e.role == "" ? "" : this.roleMap[e.role],
          };
        })
        .filter(e => this.showCompleted || !e.completed);

      return _.sortBy(unsorted, e => e.startDate);
    },
  },
  methods: {
    taskSubtitle(task) {
      var time = moment(task.startDate).format("HH:mm");
      return `${task.roleTitle} ${time}`;
    },
    async changeCompleted(task, newState) {
      const dto = {
        venueTaskId: task.venueTaskId,
        venueId: this.activeVenue.venueId,
        date: moment(this.date).format("YYYY-MM-DD"),
        checked: newState,
      };
      console.log("marking checked", dto);
      var result = await this.$store.dispatch("venueTasks/changeChecked", dto);
      if (result) this.$root.$emit("venueTaskChanged");
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-container {
  .task-title {
    color: #fff;
  }

  .task-image {
    margin: 14px auto;
    max-width: 100%;
    max-height: 140px;
  }
}
</style>
